import { createSelector } from "reselect";
import { RemoteConfigState } from "./types";
import get from "lodash/get";

export const remoteConfigs = (state: { remoteConfigs: RemoteConfigState }): RemoteConfigState =>
    state.remoteConfigs;

export const getRemoteConfigs = createSelector(
    [remoteConfigs],
    remoteConfigData => remoteConfigData
);

export const getRemoteConfig = (state: { remoteConfigs: RemoteConfigState }, config: string) => {
    const remoteConfigsData = getRemoteConfigs(state);
    return get(remoteConfigsData, config);
};
